import ListItem from '@mui/material/ListItem';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import React from 'react';
import TrueLinkButton from 'react/shared/components/true_link/main/TrueLinkButton';
import TrueLinkChip from 'react/shared/components/true_link/main/TrueLinkChip';
import TrueLinkIcon from 'react/shared/components/true_link/main/TrueLinkIcon';
import PALETTE from 'react/shared/theme/palette';

export default function ChipsButton({ chips = [], onClick }) {
  return (
    <Paper
      component={'ul'}
      style={{
        display: 'flex',
        flexDirection: 'row',
        listStyle: 'none',
        margin: '0px',
        padding: '5px',
        alignItems: 'center',
      }}
    >
      <ListItem
        style={{
          padding: '0px',
          gap: '10px',
        }}
      >
        {chips.map((chip) => (
          <TrueLinkChip
            color="primary"
            key={chip.key || chip.label}
            label={chip.label}
            onDelete={chip.onDelete}
            style={{
              color: PALETTE.emerald,
              fontWeight: 100,
              marginRight: '0px',
              marginLeft: '0px',
            }}
          />
        ))}
      </ListItem>
      <TrueLinkButton
        onClick={onClick}
        size="small"
        style={{ border: 'none', margin: '0px 0px 0px 5px', padding: '7px' }}
        variant="neutralOutline"
      >
        <TrueLinkIcon icon="caret-down" />
      </TrueLinkButton>
    </Paper>
  );
}

ChipsButton.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string.isRequired,
      onDelete: PropTypes.func,
    }),
  ),
  onClick: PropTypes.func,
};
